export const textButtonStyle = {
  py: 0.5,
  px: 1,
  fontSize: '1.2rem',
  height: '22px',
  borderRadius: '4px',
};
